package components.items

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 13.10.22
 * Author : marcusspors
 */

import core.AppContext
import core.enums.EImages
import core.ionic.IonButton
import csstype.px
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.img
import react.router.Navigate
import react.useContext
import react.useMemo
import react.useState
import screens.EScreens


external interface WatchlistIconProps : Props {
    var mIsActive: Boolean
}

val WatchlistIcon = FC<WatchlistIconProps> { props ->

    val mIsActive = props.mIsActive
    val mContext by useContext(AppContext)
    val mCount = useMemo(mContext) {
        mContext.mLocalStorageReducer.component1().mWatchlist.count()
    }

    val mSrc = useMemo(mIsActive) {
        if (mIsActive)
            EImages.WATCHLIST_ICON_TOP_APP_BAR(EImages.EType.FILLED).mRelativePath
        else
            EImages.WATCHLIST_ICON_TOP_APP_BAR(EImages.EType.OUTLINED).mRelativePath
    }


    var mNavigation: String? by useState(null)

    IonButton {
        fill = "clear"
        img {
            css {
                height = 24.px
            }
            src = mSrc

        }
        onClick = {
            if(!mIsActive) {
                mNavigation = EScreens.WATCH_LIST_SCREEN.mPath
            }
        }
    }

    mNavigation?.let {
        Navigate {
            to = it
        }
    }

}
